// const baseUrl = "http://3.111.94.93:8080/";
// const baseUrl = "http://localhost:3035/v1";
const baseUrl = "https://98mvj4whoa.execute-api.us-east-2.amazonaws.com/v1"; // master
// const baseUrl = "https://unfx69hz39.execute-api.ap-south-1.amazonaws.com/v1"; // dev

export const url = {
  addUser: baseUrl + "/user",
  getActiveUsers: baseUrl + "/getActiveusers/1",
  login: baseUrl + "/login",
  getAllUsers: baseUrl + "/users",
  getUserById: baseUrl + "user/162",
  addUserRole: baseUrl + "/userrole",
  getUserRole: baseUrl + "/userrole",
  addTrailr: baseUrl + "/trailer",
  getTrailers: baseUrl + "/trailers",
  editTrailer: baseUrl + "/trailer/",
  editUser: baseUrl + "/user/",

  addDepartment: baseUrl + "/department",
  getDepartment: baseUrl + "/departments",
  editDepartment: baseUrl + "/department/",

  addDoor: baseUrl + "/door",
  editDoor: baseUrl + "/door/",
  getDoors: baseUrl + "/doors",
  getDoorsForMoves: baseUrl + "/doorsForMoves",
  getDoorLogs: baseUrl + "/getDoorLogs",
  getDoorsByID: baseUrl + "/door/",

  addDivision: baseUrl + "/division",
  editDivision: baseUrl + "/division/",
  getDivisions: baseUrl + "/divisions",
  getDivisionByID: baseUrl + "/division/",
  getDivisionStats: baseUrl + "/divisionstats",

  addLot: baseUrl + "/lot",
  editLot: baseUrl + "/lot/",
  getLot: baseUrl + "/lots",
  getLotByID: baseUrl + "/lot/",
  getLotWithDivision: baseUrl + "/getLotsWithDivision",
  getLotByDivision: baseUrl + "/getLotsByDivision/",
  getSpaceWithLotId: baseUrl + "/getSpacesForLot",
  getSpaceLogs: baseUrl + "/getSpaceLogs",

  addDriver: baseUrl + "/driver",
  editDriver: baseUrl + "/driver/",
  getDriver: baseUrl + "/drivers",
  getDriverByID: baseUrl + "/driver/",
  addTruck: baseUrl + "/truck",
  editTruck: baseUrl + "/truck/",
  getTrucks: baseUrl + "/trucks",

  getLocationByID: baseUrl + "/location/",
  addLocation: baseUrl + "/location",
  editLocation: baseUrl + "/location/",
  getLocation: baseUrl + "/locations",
  locationsForMove: baseUrl + "/locationsForMove",

  addOffSite: baseUrl + "/offsite",
  getOffSite: baseUrl + "/offsites",
  getOffSiteRequest: baseUrl + "/getOffsiteRequest/",

  addMove: baseUrl + "/move",
  getMove: baseUrl + "/moves",
  getMoveByTypes: baseUrl + "/getMovesByTypes/",
  deleteMove: baseUrl + "/move",
  doorsForMoves: baseUrl + "/doorsForMoves",

  getContainers: baseUrl + "/outsideCarrierContainers",
  createContainer: baseUrl + "/outsideCarrierContainer",
  spaceFrom: baseUrl + "/getOccupiedSpaces",
  spaceTo: baseUrl + "/getEmptySpaces",

  getTrailersWithLatestLog: baseUrl + "/getTrailersWithLatestLog",
  getTrailerLogs: baseUrl + "/trailerLogs",

  addCorrection: baseUrl + "/correctionLog",
  getCorrectionLog: baseUrl + "/correctionLogs/",

  createLotWorksheet: baseUrl + "/createLotWorksheet",
  createDoorWorksheet: baseUrl + "/createDoorWorksheet",
  doorBulk: baseUrl + "/doorBulk",
  spaceBulk: baseUrl + "/spacesBulk",
  lotsBulk: baseUrl + "/lotsBulk",
  divisionBulk: baseUrl + "/divisionBulk",
  userBulk: baseUrl + "/userBulk",
  trailerBulk: baseUrl + "/trailerBulk",
  createReports: baseUrl + "/reports",

  getNotifications: baseUrl + "/notifications",
  edittNotifications: baseUrl + "/markAsRead",

  forgotpassword: baseUrl + "/forgotpassword",
  confirmpassword: baseUrl + "/confirmpassword",

  getCurrentDoorOccupancyURL: baseUrl + "/getCurrentDoorOccupancy/",
  getCurrentSpaceOccupancyURL: baseUrl + "/getCurrentSpaceOccupancy/",
};
